$(document).ready(function () {
  $('a.button').on('click',function(){
    let target = $(this).attr('href')
    $('html, body').animate({
      scrollTop: $(target).offset().top
  }, 2000);
  });

  var initGridAddToCart = function(){
    $('.quick-addtocart').on('submit', function(e){
      e.preventDefault();
      var variant_id = $(this).find('input[name="id"]').val();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variant_id,
          quantity: 1
        },
        dataType: 'json',
        async: false,
        success: function(data) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data
            }
          }));
        }
      });
    });
  };

  initGridAddToCart();

  $(document).on('collectionFilter:complete', function(){
    initGridAddToCart();
  });

});